var styles = {
  "TextInput": "pb-TextInput__TextInput",
  "Invalid": "pb-TextInput__Invalid",
  "fullWidth": "pb-TextInput__fullWidth"
};
export default styles;